module.exports = __webpack_public_path__ + "img/27.35b7f7c8.jpg";